import activityTypes from 'helpers/enums/activityTypes'
import draftStateTypes from 'helpers/enums/interactiveVideo/draftStateTypes'

const defaultDraftOeq = {
	value: '',
	state: draftStateTypes.ENABLED,
	isEditing: false,
}
const defaultDraftMcq = {
	value: [],
	state: draftStateTypes.ENABLED,
	isEditing: false,
}
const defaultDraftPoll = {
	value: [],
	state: draftStateTypes.ENABLED,
	isEditing: false,
}

const defaultDraftByActivityType = {
	[activityTypes.OPEN_ENDED_QUESTION]: defaultDraftOeq,
	[activityTypes.POLL_QUESTION]: defaultDraftPoll,
	[activityTypes.MULTIPLE_CHOICE_QUESTION]: defaultDraftMcq,
}

export {
	defaultDraftByActivityType,
}
